<template>
  <a
    v-if="!isExpired"
    :href="promo.booking_url"
    class="promo-banner"
    target="_blank"
    rel="noopener"
  >
    <div class="promo-banner__track">
      <div class="promo-banner__group">
        <span v-for="n in 8" :key="n" class="promo-banner__item" v-html="promo.content"></span>
      </div>

      <div class="promo-banner__group" aria-hidden="true">
        <span v-for="n in 8" :key="n" class="promo-banner__item" v-html="promo.content"></span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'PromoBanner',

  data() {
    return {
      now: Date.now(),
    }
  },

  computed: {
    promo() {
      return this.$beet.options.banner
    },

    isExpired() {
      return this.now >= new Date(this.promo.expires_at).getTime()
    },
  },

  mounted() {
    this.expirationTimer = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },

  beforeUnmount() {
    clearInterval(this.expirationTimer)
  },
}
</script>
